import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon, DownloadIcon } from 'lucide-react';
export function FinalOffer() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="precio" ref={ref} className="w-full bg-[#1e293b] text-white py-20 md:py-32" data-id="element-39">
      <div className="max-w-4xl mx-auto px-6" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 40
      }} transition={{
        duration: 0.8
      }} className="space-y-12" data-id="element-41">
          <div className="text-center space-y-6" data-id="element-42">
            <h2 className="text-3xl md:text-4xl lg:text-5xl text-white" data-id="element-43">
              Recupera Tus Noches y Tu Vitalidad Hoy Mismo
            </h2>

            <div className="bg-[#0f172a] p-8 md:p-12 rounded-xl shadow-2xl space-y-6" data-id="element-44">
              <div className="space-y-4" data-id="element-45">
                <p className="text-gray-400 text-lg line-through" data-id="element-46">
                  Valor regular: $47 USD
                </p>
                <div className="flex items-baseline justify-center gap-2" data-id="element-47">
                  <span className="text-5xl md:text-6xl font-bold text-[#d4a853]" data-id="element-48">
                    $6.39
                  </span>
                  <span className="text-2xl text-gray-300" data-id="element-49">USD</span>
                </div>
                <span className="inline-block bg-[#d4a853] text-[#0f172a] text-sm font-bold px-4 py-1.5 rounded-full" data-id="element-50">
                  86% DE DESCUENTO
                </span>
                <p className="text-xl text-gray-300" data-id="element-51">
                  Pago único · Sin suscripciones
                </p>
              </div>

              <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-52">
                Menos de lo que cuesta un frasco de pastillas que no resuelve la
                raíz del problema.
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6 text-center" data-id="element-53">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            delay: 0.2,
            duration: 0.6
          }} className="space-y-3" data-id="element-54">
              <ShieldCheckIcon className="w-10 h-10 text-[#d4a853] mx-auto" data-id="element-55" />
              <p className="text-gray-300" data-id="element-56">Pago 100% Seguro</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            delay: 0.3,
            duration: 0.6
          }} className="space-y-3" data-id="element-57">
              <ZapIcon className="w-10 h-10 text-[#d4a853] mx-auto" data-id="element-58" />
              <p className="text-gray-300" data-id="element-59">Acceso Instantáneo</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            delay: 0.4,
            duration: 0.6
          }} className="space-y-3" data-id="element-60">
              <DownloadIcon className="w-10 h-10 text-[#d4a853] mx-auto" data-id="element-61" />
              <p className="text-gray-300" data-id="element-62">Descarga Inmediata</p>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          delay: 0.5,
          duration: 0.6
        }} className="flex flex-col items-center gap-4" data-id="element-63">
            <motion.a href="https://learniacademy.com/cart/53216466239853:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.98
          }} className="inline-block w-full sm:w-auto bg-[#d4a853] text-[#0f172a] px-12 py-6 rounded-lg text-xl font-bold shadow-lg hover:shadow-xl transition-shadow text-center cursor-pointer" data-id="element-64">
              ¡SÍ, QUIERO DORMIR MEJOR!
            </motion.a>
            <p className="text-sm text-gray-400" data-id="element-65">
              Pago 100% seguro · Acceso instantáneo a tu guía PDF
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}